import { addDays, limitOn, tallyRange } from '@tahi/core';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { Money, ScreenHeader } from '../../../ui';
import { spokenPeso } from '../../../ui/spokenPeso';
import { copy, QUIT_BACK } from '../copy';
import { QUIT_BASE } from '../dashboardDefaults';
import { countLine, dayLabel } from '../format';
import { useQuitData, useQuitToday } from '../hooks';
import { FOCUS, INPUT, PILL_BTN, SCREEN } from '../styles';

/** The last 30 days, newest first; any day opens the editor, and older days are reached by date. */
export function HistoryScreen() {
  const data = useQuitData();
  const today = useQuitToday();
  const navigate = useNavigate();
  const [pick, setPick] = useState('');
  if (!data) {
    return (
      <main className={SCREEN}>
        <ScreenHeader title={copy.historyTitle} back={QUIT_BACK} />
        <p role="status" className="text-muted">
          {copy.loading}
        </p>
      </main>
    );
  }
  const taper = data.plan?.taper ?? [];
  const days = tallyRange(data.logs, { start: addDays(today, -29), end: today }).reverse();

  return (
    <main className={SCREEN}>
      <ScreenHeader title={copy.historyTitle} back={QUIT_BACK} />
      <form
        className="flex items-end gap-2"
        onSubmit={(e) => {
          e.preventDefault();
          if (pick) navigate(`${QUIT_BASE}/day/${pick}`);
        }}
      >
        <label className="flex flex-1 flex-col gap-1 text-sm text-muted">
          {copy.backfill}
          <input
            type="date"
            max={today}
            value={pick}
            onChange={(e) => setPick(e.target.value)}
            className={INPUT}
          />
        </label>
        <button type="submit" className={PILL_BTN}>
          {copy.open}
        </button>
      </form>
      <ul className="flex flex-col divide-y divide-divider">
        {days.map((d) => {
          const line = countLine(d.count, limitOn(taper, d.date));
          const name = `${dayLabel(d.date, today)}, ${line}${d.costMinor > 0 ? `, ${spokenPeso(d.costMinor)}` : ''}`;
          return (
            <li key={d.date}>
              <Link
                to={`${QUIT_BASE}/day/${d.date}`}
                aria-label={name}
                className={`flex min-h-11 items-center justify-between gap-3 rounded-xl px-2 py-2 ${FOCUS}`}
              >
                <span className="text-fg">{dayLabel(d.date, today)}</span>
                <span className="flex items-center gap-3">
                  <span className="font-mono tabular-nums text-fg">{line}</span>
                  {d.costMinor > 0 ? (
                    <Money minor={d.costMinor} className="text-sm text-muted" />
                  ) : null}
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </main>
  );
}
